import React, { useState } from 'react';

import { ActionIcon, Button, Divider, Group, Stack, TextInput, useMantineTheme } from '@mantine/core';
import { IconSearch, IconX } from '@tabler/icons-react';

import useFilteredExpectations from './useFilteredExpectations';
import { useModal } from '../../Context/ModalContext';
import ExpectationsTable from '../Components/ExpectationsTable';

const ListExpectationsForm = (): JSX.Element => {
  const theme = useMantineTheme();

  const [search, setSearch] = useState('');
  const { data, isLoading, isSuccess, isError } = useFilteredExpectations(search);

  const { openModal } = useModal();

  return (
    <Stack sx={{ height: '100%' }}>
      <TextInput
        placeholder='Search packages'
        value={search}
        onChange={e => setSearch(e.currentTarget.value)}
        icon={<IconSearch size={theme.fontSizes.md} />}
        rightSection={
          search && (
            <ActionIcon onClick={() => setSearch('')} size='xs' variant='transparent'>
              <IconX />
            </ActionIcon>
          )
        }
      />
      <ExpectationsTable data={data} isLoading={isLoading} isSuccess={isSuccess} isError={isError} />

      <Divider my='md' />

      <Group position='right'>
        <Button variant='filled' onClick={() => openModal('register')}>
          Add Packages
        </Button>
      </Group>
    </Stack>
  );
};

export default ListExpectationsForm;
